import React from "react";
import PropTypes from "prop-types";

import MuiFormControl from "@mui/material/FormControl";
import MuiInputLabel from "@mui/material/InputLabel";
import MuiSelect from "@mui/material/Select";
import MuiMenuItem from "@mui/material/MenuItem";
import MuiFormHelperText from "@mui/material/FormHelperText";

const DropdownLabeled = (props) => {
  const {
    name,
    label,
    value,
    onChange,
    items,
    helperText,
    error,
    ...otherProps
  } = props;
  const labelId = `${name}-drop-down-label-id`;
  const selectListId = `${name}-options-list-id`;
  return (
    <MuiFormControl fullWidth error={error} {...otherProps}>
      <MuiInputLabel id={labelId}>{label}</MuiInputLabel>
      <MuiSelect
        name={name}
        labelId={labelId}
        id={`${name}-select-id`}
        value={value}
        label={label}
        onChange={onChange}
        MenuProps={{ MenuListProps: { id: selectListId } }}
        SelectDisplayProps={{ "aria-controls": selectListId }}
      >
        {items &&
          items.map((item) => (
            <MuiMenuItem
              variant="dropdown"
              value={item}
              key={`drop-down-item-${item}`}
            >
              {item}
            </MuiMenuItem>
          ))}
      </MuiSelect>
      {helperText && <MuiFormHelperText>{helperText}</MuiFormHelperText>}
    </MuiFormControl>
  );
};

DropdownLabeled.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  items: PropTypes.array,
  helperText: PropTypes.string,
  error: PropTypes.bool,
};

export default DropdownLabeled;
